// Use a URL constructor to reference the file. 
// If it's missing, Parcel might still warn, but it's less brittle than a direct JS import if configured right.
// However, standard Parcel behavior requires the asset to exist.
// We accepted the risk, but let's use the URL pattern as requested for "graceful" handling logic in code later.
// We accepted the risk, but let's use the URL pattern as requested for "graceful" handling logic in code later.
const slipsUrl = new URL('./data/slips.geojson', import.meta.url).href;
const areaMaskUrl = new URL('./data/area-mask.geojson', import.meta.url).href;

export interface SourceOption {
    url: string;
    type: 'raster' | 'vector' | 'geojson';
    scheme?: 'xyz' | 'tms';
    name: string;
    date: string;
    attribution?: string;
}

export interface LayerConfig {
    id: string;
    sourceId: string;
    options: SourceOption[];
}


export interface VectorLayerConfig {
    id: string;
    sourceId: string;
    name: string;
    type: 'geojson' | 'vector';
    url: string; // The bundled URL to the geojson or pmtiles:// URL
    sourceLayer?: string;
}

export const AppConfig = {
    map: {
        center: [178.3811, -37.6358] as [number, number],
        zoom: 12,
        maxZoom: 19,
        // Using globe projection for a nicer look if strictly supported, but 'mercator' is standard for base maps
        projection: 'mercator'
    },
    layers: {
        before: {
            id: 'before-layer',
            sourceId: 'before-source',
            options: [
                {
                    name: 'Satellite Imagery',
                    date: '8th December 2025',
                    type: 'raster',
                    scheme: 'tms',
                    url: 'before/{z}/{x}/{y}.png',
                    attribution: 'S3-Processed'
                },
                {
                    name: 'LINZ Aerial',
                    date: 'Baseline',
                    type: 'raster',
                    url: 'https://basemaps.linz.govt.nz/v1/tiles/aerial/3857/{z}/{x}/{y}.png?api=d01jcc4gp3kyhgpmgarmxg201j0',
                    attribution: 'LINZ'
                }
            ]
        } as LayerConfig,
        after: {
            id: 'after-layer',
            sourceId: 'after-source',
            options: [
                {
                    name: 'Satellite Imagery',
                    date: '31st January 2026',
                    type: 'raster',
                    scheme: 'tms',
                    url: 'after/{z}/{x}/{y}.png',
                    attribution: 'Sentinel-2-Processed'
                },
                {
                    name: 'No Imagery',
                    date: '-',
                    type: 'raster',
                    url: 'empty',
                    attribution: ''
                }
            ]
        } as LayerConfig,
        slips: {
            id: 'slips-layer',
            sourceId: 'slips-source',
            name: 'Impacts',
            type: 'vector',
            // Use pmtiles protocol. 
            // NOTE: new URL(...) will be resolved by Parcel to the actual hashed file location.
            // Use .bin extension to prevent GitHub Pages from Gzipping the file,
            // which breaks range requests and decoding in some browsers (e.g., Firefox).
            url: 'pmtiles://' + new URL('./data/impact.bin', import.meta.url).href,
            sourceLayer: 'impact'
        } as VectorLayerConfig,
        areaMask: {
            id: 'area-mask-layer',
            sourceId: 'area-mask-source',
            name: 'Analysed Area',
            type: 'geojson',
            url: areaMaskUrl
        } as VectorLayerConfig,
        labels: {
            id: 'labels-layer',
            sourceId: 'labels-source',
            name: 'Place Names',
            type: 'raster',
            url: 'https://cartodb-basemaps-a.global.ssl.fastly.net/light_only_labels/{z}/{x}/{y}.png',
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
        }
    }
};
